import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { getStyles } from '../../../shared/utility';

import Gallery from '../Gallery/Gallery';
import CardContent from './CardContent/CardContent';
import Bar from '../Loading/Bar/Bar';

import localStyles from './Card.scss';
const styles = getStyles(localStyles);

const card = (props) => {
    const gallery = (
        <div className={styles('card__gallery', `card__gallery--${props.viewMode}`)}>
            {props.loading ? <Bar modifiers={['no-animation', 'fillout']} /> : <Gallery images={props.item.imageReferences} />}
        </div>
    );

    const contentClasses = ['card__content', `card__content--${props.viewMode}`]
        .concat(props.viewMode === 'list' ? ['flex', 'flex--column', 'flex--justify-between'] : null);

    const content = (
        <div className={styles(contentClasses)}>
            <CardContent
                loading={props.loading}
                item={props.loading ? null : props.item}
                viewMode={props.viewMode}
            />
        </div>
    );

    const cardClasses = ['card', `card--${props.viewMode}`, 'no-text-decoration']
        .concat(props.viewMode === 'list' || props.viewMode === 'card' ? 'flex' : null)
        .concat(props.viewMode === 'card' ? 'flex--column' : null)
        .concat(props.loading ? 'card--loading' : null);

    return props.loading ? (
        <div className={styles(cardClasses)}>
            {gallery}
            {content}
        </div>
    ) : props.viewMode !== 'map' ? (
        <NavLink className={styles(cardClasses)} to={'/item/' + props.item.id}>
            {gallery}
            {content}
        </NavLink>
    ) : (
        <div className={styles(cardClasses)}>
            {gallery}
            {content}
            <div className={styles('card__arrow')}/>
        </div>
    );

};

card.propTypes = {
    // properties
    item: PropTypes.object,
    loading: PropTypes.bool,
    viewMode: PropTypes.string.isRequired
};

export default card;



// WEBPACK FOOTER //
// ./src/components/UI/Card/Card.js